<span><a href="#/main" ><img class="logo ms-3 mt-4 mb-3" [ngClass]="{'wrap': !expanded}"  src="/assets/img/top-logo.png" alt="" /></a></span>

<a class="menu-item w-100 p-1 align-items-center justify-content-start d-flex text-light" [routerLink]="item.href" routerLinkActive="active-link" *ngFor="let item of menuService.getMenu()">
    <mat-icon class="menu-icon">{{item.matIcon}}</mat-icon>
    <span *ngIf="expanded">{{ item.label }}</span>
</a>
